/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Delete_ErrorInputs */

const en_doc_delete_error = /** @type {(inputs: Doc_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not delete the document. Please try again.`)
};

const pt_br2_doc_delete_error = /** @type {(inputs: Doc_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível excluir o documento. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Could not delete the document. Please try again." |
*
* @param {Doc_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_delete_error = /** @type {((inputs?: Doc_Delete_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Delete_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_delete_error(inputs)
	return pt_br2_doc_delete_error(inputs)
});